import { recordUIEventAction } from '@app-worker/uiEvent/recordUIEventAction';
import { UIEventType } from '@repo/entities/UIEventType';
import { AppAutoRefreshedMetadata } from '@repo/entities/UIEventMetadata';

// Not a react-query hook: the reload must await the record, and a
// fire-and-forget mutation would be killed mid-flight.
export async function recordAutoRefresh(event: AppAutoRefreshedMetadata) {
  await recordUIEventAction({
    record: {
      eventType: UIEventType.AppAutoRefreshed,
      metadata: event,
    },
    // Sent as it happens: the reload waits for it, so it never queues.
    bufferedMs: undefined,
  });
}
